import client from './client';

export const getCharacters = async (gameId, params = {}) => {
  const response = await client.get(`/api/games/${gameId}/characters`, { params });
  return response.data;
};

export const getCharacter = async (gameId, characterId) => {
  const response = await client.get(`/api/games/${gameId}/characters/${characterId}`);
  return response.data;
};

export const createCharacter = async (gameId, characterData) => {
  const response = await client.post(`/api/games/${gameId}/characters`, characterData);
  return response.data;
};

export const updateCharacter = async (gameId, characterId, characterData) => {
  const response = await client.put(`/api/games/${gameId}/characters/${characterId}`, characterData);
  return response.data;
};

export const deleteCharacter = async (gameId, characterId) => {
  const response = await client.delete(`/api/games/${gameId}/characters/${characterId}`);
  return response.data;
};

export const addCharacterAspect = async (gameId, characterId, aspectData) => {
  const response = await client.post(`/api/games/${gameId}/characters/${characterId}/aspects`, aspectData);
  return response.data;
};

export const removeCharacterAspect = async (gameId, characterId, aspectIndex) => {
  const response = await client.delete(`/api/games/${gameId}/characters/${characterId}/aspects/${aspectIndex}`);
  return response.data;
};

export const addCharacterToScene = async (gameId, sceneId, characterId) => {
  const response = await client.post(`/api/games/${gameId}/scenes/${sceneId}/characters/${characterId}`);
  return response.data;
};

export const removeCharacterFromScene = async (gameId, sceneId, characterId) => {
  const response = await client.delete(`/api/games/${gameId}/scenes/${sceneId}/characters/${characterId}`);
  return response.data;
};
